import React from "react";
import ModalShell from "./ModalShell";

const FIELDS = [
  { key: "name", label: "Name :", type: "text" },
  { key: "email", label: "Email :", type: "email" },
  { key: "phone_number", label: "Phone Number :", type: "text" },
];

const EditCandidateModal = ({ form, setForm, onClose, onSubmit, disabled }) => (
  <ModalShell title="Edit Candidate" maxWidth={500} onClose={onClose} closeOnBackdrop={false}>
    <div className="jv2-modal-body" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      {FIELDS.map((f) => (
        <div key={f.key} className="modal-input-label">
          <label>{f.label}</label>
          <input type={f.type} value={form[f.key]} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} />
        </div>
      ))}
    </div>
    <div className="jv2-modal-footer">
      <button className="jv2-modal-cancel" onClick={onClose}>Cancel</button>
      <button className="jv2-modal-confirm" disabled={disabled} onClick={onSubmit}>Submit</button>
    </div>
  </ModalShell>
);

export default EditCandidateModal;
